import EventApi from '@/api/event';

const AutopayBenefitEventApi = {
  /**
   * 대상자 조회, 선택한 경품 확인 api
   * @param type checkEventUser(이벤트 대상자인지 체크), getBenefitData(선택된 혜택 조회)
   * @return {Promise<void>}
   */
  autoPayEventInfo: async (type) => {
    try {
      const response = await EventApi.get(`/autopay_benefit.php?work=${type}`);
      return response;
    } catch (e) {
      return e.response;
    }
  },
  /**
   * 경품 선택 api
   * @params benefit coffee | quickview | sub
   * @return {Promise<void>}
   */
  pickBenefit: async (benefit) => {
    try {
      const response = await EventApi.post('/autopay_benefit.php', {
        work: 'pickBenefit',
        benefit,
      });
      return response;
    } catch (e) {
      return e.response;
    }
  },
};
export default AutopayBenefitEventApi;
